import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";
import { useEffect } from "react";
import { AdminProviders } from "@/app/providers";
import { router } from "@/app/router";
import { setTokenGetter } from "@/api/client";
import { EnvironmentProvider } from "@/shared/env";
import { Toaster } from "@/shared/components/toaster";
import "@/styles/globals.css";

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function ClerkTokenBridge() {
  const { getToken } = useAuth();
  useEffect(() => {
    setTokenGetter(getToken);
  }, [getToken]);
  return null;
}

function App() {
  return (
    <ClerkProvider
      publishableKey={clerkKey}
      telemetry={false}
      appearance={{
        baseTheme: dark,
        variables: {
          colorPrimary: "#52a8ad",
          colorBackground: "#121a22",
          colorInputBackground: "#1a2228",
          colorText: "#ffffff",
        },
      }}
    >
      <EnvironmentProvider>
        <AdminProviders>
          <ClerkTokenBridge />
          <RouterProvider router={router} />
          <Toaster />
        </AdminProviders>
      </EnvironmentProvider>
    </ClerkProvider>
  );
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");
const root = createRoot(rootEl);
root.render(<App />);
